// for upcoming configurations

export function darkThemeFunc(themeSvc: any, profileSvc: any): string {
  return 'dark-theme';
}

export function lightThemeFunc(themeSvc: any, profileSvc: any): string {
  return themeSvc.getActiveUserOrg()?.toLowerCase() === 'unibz'
    ? 'unibz'
    : 'eurac';
}

export const layout = {
  theme: {
    defaultOrg: 'unibz', // default org. i.e some apps are only for unibz and some only for eurac.
    themeSwitch: {
      // Dropdown options for theme Switch
      showOptions: true, // whether the theme switch should be visible or not in the topbar dropdown
      options: [
        {
          label: 'Dark theme',
          themeName: darkThemeFunc,
        },
        {
          label: 'Light theme',
          themeName: lightThemeFunc,
        },
      ],
    },
    allowedThemes: [
      // theme that can be applied. In future if we want to avoid a particular theme for a particular app.
      { name: 'dark-theme', attrType: 'class', enabled: true },
      { name: 'unibz', attrType: 'id', enabled: true },
      { name: 'eurac', attrType: 'id', enabled: true },
    ],
    // i.e if windows or Linux has dark mode, then apply the dark mode also to the app.
    enableOSDefaultTheme: true,
    // i.e if app a use dark theme, then user switch to app b
    // and app b will have also the dark mode if dark-theme is allowed.
    enableDarkThemeFromCache: true,
  }, // theme options
  breadcrumb: {
    debug: false, // dev might want to know how the breadcrumb item is generated.
    visible: true, // whole breadcrumb should be visible or not
    showAppNameInBreadcrumb: true, // the application name should be visible or not
    showHomeInBC: false, // the application name should be visible or not
    lastBCItemsVisibleOnMobile: 2, // number of BC items to be visible on mobile.
    lastBCItemsVisibleAtMost: 4, // number of BC items to be visible.
    truncateNameLenOnMobile: 18, // truncate bc name on mobile view
    truncateNameLenOnDesktop: 26, // truncate after given value the name of breadcrumb on desktop
    truncateLastItemOnDesktop: true, // will truncate last item only
    truncateNameOnDesktop: true, // whether to truncate name on the desktop or not
    mobileBreakpoint: 'small' // value from this.mediaBreakpoints.small
  },
  i18n: {
    isAppMultiLingual: false,
    languages: ['it', 'de', 'en'],
    // languages: ['en'],
    fallback: 'en',
  },
  assets: {
    images: {
      snsLogo: {
        publicPath: 'public/assets/v7/latest/img/sns-logo.svg',
      },
      snsLogoText: {
        publicPath: 'public/assets/v7/latest/img/sns-logo-text.svg',
      },
    },
  },
  debug: {
    debugLevel: 0, // 0 - 5, where 0 shows only errors and 5 shows everything
    enableDebugLog: true,
    showLogComingFrom: false, // not usable
  },
  appRouteHistory: {
    registerHistoryForApp: true,
  },
  mediaBreakpoints: {
    xSmall: 480, /* For extremely small screen devices ( till 480 ); Mobile Devices */
    small: 768, /* Small screen devices (from 480 to 768px): Tablets */
    medium: 1024, /* Medium screen devices (768px and above) Small Screen */
    normal: 1200, /* Big screen devices (889px and above) DESKTOPS Screen */
    large: 1400, /* for big screens */
  },
  notificationsCommunications: {
    enable: false
  },
  todosCommunication: {
    enable: false
  }
};
